export default __webpack_public_path__ + "static/media/zazabor-full.90c7b8bc.png";